import { render, staticRenderFns } from "./CustomerLatestUpdates.vue?vue&type=template&id=7e94f6c5"
import script from "./CustomerLatestUpdates.vue?vue&type=script&lang=js"
export * from "./CustomerLatestUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports